export type ImageOverlayRect = {top: number; left: number; width: number; height: number};

export function applyIndicatorRect(node: HTMLElement, rect: ImageOverlayRect) {
  node.style.top = `${rect.top}px`;
  node.style.left = `${rect.left}px`;
  node.style.height = `${rect.height}px`;
}
